import "../buttons.scss"

const DiscardButton = ({onClick, title}) => {
    return (
        <button className="discard-btn" onClick={onClick}>{title ? title : "Discard"}</button>
    )
}

export default DiscardButton;